import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { IMasterListHeader } from '../../../entity-master/components/master-list/master-list.interface';
import { IRouter } from '../../../shared/interfaces/router.interface';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Injectable()
export class TransactionHistoryBuilder {
  constructor(
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _translateService: TranslateService
  ) {}

  buildGoBackRoute(
    route: string,
    documentTrackingObject: ITrackingObject,
    trackingScreenName: TrackingScreenNamesEnum
  ): IRouter {
    return {
      route: [route],
      trackingObject: documentTrackingObject,
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'back',
        trackingScreenName
      ),
      navigationExtras: {
        replaceUrl: true,
      },
    };
  }

  buildHeaders(): List<IMasterListHeader> {
    const listHeaders: IMasterListHeader[] = [
      {
        id: 'date',
        label: this._translateService.instant('LABEL.DATE'),
        customClass: 'transaction-date',
      },
      {
        id: 'description',
        label: this._translateService.instant('LABEL.DESCRIPTION'),
        customClass: 'transaction-description',
      },
      {
        id: 'status',
        label: this._translateService.instant(
          'DOCUMENT.INVOICE.LIST_HEADERS.STATUS'
        ),
        customClass: 'transaction-status',
      },
      {
        id: 'balance',
        label: this._translateService.instant('LABEL.TOTAL'),
        customClass: 'transaction-amount',
      },
    ];

    return List(listHeaders);
  }
}
